import React, { useEffect } from 'react';
import { useTheme } from '../context/ThemeContext';
import { TopBar } from '../components/layout/TopBar';
import DarshanPathsPage from './DarshanPathsPage';

export const PublicDarshanPathpage: React.FC = () => {
  const { setTheme } = useTheme();

  useEffect(() => {
    setTheme('light');
  }, [setTheme]);

  return (
    <div className="min-h-screen flex flex-col bg-[#FBF9F5] dark:bg-[#111215] text-neutral-800 dark:text-neutral-100 transition-colors duration-200">
      <TopBar hideBanner />
      <main className="flex-1 w-full mx-auto px-2 sm:px-4 py-0.5">
        <DarshanPathsPage isPublic={true} />
      </main>
    </div>
  );
};

export default PublicDarshanPathpage;
